module.exports = __webpack_public_path__ + "img/04n.ed83f19a.png";